import '../App.css';
import NavBar from '../components/navbar';
import ChatBot from '../images/chatbot.png';
import WorkFlow from '../images/manage.png';
import AIAgent from '../images/neural.png';

import { useNavigate } from 'react-router-dom';

function Services() {

    const navigate = useNavigate()

    return (
        <div className="homepage">
            <NavBar /> 
            <div className="servicestextpage"><b>We build practical, custom AI systems that help businesses automate workflows, save time, and grow smarter. Every solution is tailored to your unique operations and goals.</b></div>
            <div className="servicesection page">
                <div className="servicecontainer page">
                    <img className="chatbotimage" src={ChatBot} alt="chatbotimage" />
                    <div className="custom"><b>Custom Chatbot</b></div>
                    <ul className="servicelist page">
                        <li>Instantly answer customers questions 24/7</li>
                        <li>Handles FAQs, bookings, and lead capture</li>
                        <li>Reduces support workload by up to 60%</li>
                    </ul>
                </div>
        
                <div className="servicecontainer page">
                    <img className="chatbotimage" src={WorkFlow} alt="workflow" />
                    <div className="custom"><b>Workflow <br /> Automation</b></div>
                    <ul className="servicelist page">
                        <li>Automate emails, documents, and data entry</li>
                        <li>Integrate with tools like Notion, Zapier, Google Sheets</li>
                        <li>Eliminate repetitive tasks across your team</li>
                    </ul>
                </div>
            
                <div className="servicecontainer page">
                    <img className="chatbotimage" src={AIAgent} alt="Agent" />
                    <div className="custom"><b>AI Agent </b></div>
                    <ul className="servicelist page">
                        <li>Personal assistants for research, writing, and insights</li>
                        <li>Trained on your processes and tone</li>
                        <li>Supports decision-making with real-time data</li>
                    </ul>
                </div>
            </div>
            <div className="letsbuild" style={{marginTop: '10%'}}>
                <div className="buildmaintext"><b>Not sure which service is best for your business</b></div>
                <div className="consultbutton bottom" style={{ marginTop: '3%', marginBottom: '5%' }} onClick={() => navigate('/consultation')} >Free Consultation</div>
            </div>

        </div>
    )
}

export default Services